import inventory from '@/api/report/inventory'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  }
}

export const actions = {
  // generate daily sale item pdf
  dailySaleItem(context, attributes = {}) {
    return inventory.dailySaleItem({ params: attributes })
  },
  // generate daily sale item excel
  dailySaleItemExcel(context, payload) {
    return inventory.dailySaleItemExcel(payload)
  },
  // generate sale item details
  saleItemDetail(context, attributes = {}) {
    return inventory.saleItemDetail({ params: attributes })
  },
  // generate stock in detail as pdf
  stockInDetail(context, attributes = {}) {
    return inventory.stockInDetail({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // export stock in detail as excel
  stockInDetailExcel(context, payload) {
    return inventory.stockInDetailExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  },
  // generate stock in summary
  stockInSummary(context, attributes = {}) {
    return inventory.stockInSummary({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // export stock in summary
  stockInSummaryExcel(context, payload = {}) {
    return inventory.stockInSummaryExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  },
  // generate detail inventory list
  detailInventoryList(context, attributes = {}) {
    return inventory.detailInventoryList({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // generate summary inventory list
  summaryInventoryList(context, attributes = {}) {
    return inventory.summaryInventoryList({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // export summary inventory list excel
  summaryInventoryListExcel(context, payload = {}) {
    return inventory.summaryInventoryListExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  },
  // generate product item
  productItemList(context, attributes = {}) {
    return inventory.productItemList({ params: attributes })
  },
  // generate purchase order list
  purchaseOrderList(context, attributes = {}) {
    return inventory.purchaseOrderList({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // generate purchase order list
  purchaseOrderSummary(context, attributes = {}) {
    return inventory.purchaseOrderSummary({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // generate monthly sale item
  monthlySaleItem(context, data) {
    return inventory.monthlySaleItem(data)
  },
  // generate monthly sale item as excel
  monthlySaleItemExcel(context, payload) {
    return inventory.monthlySaleItemExcel(payload)
  },
  // generate stock transfer
  stockTransfer(context, attributes = {}) {
    return inventory.stockTransfer({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // generate stock transfer as excel
  stockTransferExcel(context, payload) {
    return inventory.stockTransferExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        payload
      )
    )
  },
  // generate yearly sale items
  yearlySaleItem(context, attributes = {}) {
    return inventory.yearlySaleItem({ params: attributes })
  },
  productList(context) {
    return inventory.productList()
  },
  productSerial(context, data) {
    return inventory.productSerial(data)
  },
  detailInventoryListToExcel(context, data){
    return inventory.detailInventoryListToExcel(Object.assign({
      date_from: context.state.date_from,
      date_to: context.state.date_to
    }, data))
  }
}
